import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BrandState {
  name: string;
  logoUrl: string | null;
  primaryColor: string | null;
  secondaryColor: string | null;
}

const initialState: BrandState = {
  name: "eSIM Console",
  logoUrl: null,
  primaryColor: null,
  secondaryColor: null,
};

const brandSlice = createSlice({
  name: "brand",
  initialState,
  reducers: {
    setBrandConfig: (state, action: PayloadAction<BrandState>) => {
      state.name = action.payload.name;
      state.logoUrl = action.payload.logoUrl;
      state.primaryColor = action.payload.primaryColor;
      state.secondaryColor = action.payload.secondaryColor;
    },
  },
});

export const { setBrandConfig } = brandSlice.actions;
export default brandSlice.reducer;
